import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import PageHeading from "../components/pageheading";
import CallToAction from '../components/cta'

import "../styles/global.scss";

export default function OurVehicles( { data } ) {
  return (
    <Layout>
      <div className="vehicles">
        <PageHeading heading="Our Vehicles" />

        <div className="block-one">
          <div className="text-l">
            <h4>UK wide coverage with thousands of vehicles</h4>
            <p>
              To ensure we’ve got your consignment covered, we have a number of
              vehicles at our disposal to make sure your goods arrive safely to
              your chosen destination.
              <br />If we don’t have your vehicle available immediately, we’ll
              do our best to get it for you; so it’s always worth getting in
              touch with our team.
            </p>
          </div>
          <div className="img-r">
            <Img
              fluid={ data.mountain.childImageSharp.fluid }
              alt="van moving fast on mountain"
            />
          </div>
        </div>

        <PageHeading
          id="vehicle-size-heading"
          heading="Smaller Vehicles"
        />

        <div className="block">
          <div className="text-l">
            <h4>Motorbike</h4>
            <p>Jiffy bags, documents and small packages.</p>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="img-r">
            <Img
              fluid={ data.motorbike.childImageSharp.fluid }
              alt="courier motorbike"
            />
          </div>
        </div>

        <div className="block">
          <div className="text-r">
            <h4>Car</h4>
            <p>Small boxes, lever arch files and so on.</p>
            <CallToAction to='/quote_request' text='Request Quote' />
          </div>

          <div className="spacer"></div>
          <div className="img-l">
            <Img fluid={ data.car.childImageSharp.fluid } alt="small car" />
          </div>
        </div>
        <div className="block">
          <div className="text-l">
            <h4>Small Courier Van</h4>
            <ul>
              <li>Payload (Kg): 300kg - 500kg</li>
              <li>1 Standard UK/Euro Pallet</li>
              <li>Dimensions 1.40m (L) x 1.20m (W) x 1.20m (H)</li>
              <li>Body Cube (cbm): 2.95</li>
              <li>Refrigerated transport option also available (UK only)</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="img-r">
            <Img
              fluid={ data.smallVan.childImageSharp.fluid }
              alt="small courier van"
            />
          </div>
        </div>
        <PageHeading
          id="vehicle-size-heading"
          heading="Medium Vehicles"
        />
        <div className="block">
          <div className="text-r">
            <h4>Medium Wheelbase Van</h4>
            <ul>
              <li>Payload (Kg): 600 - 900kg</li>
              <li>2 Standard UK/Euro Pallets</li>
              <li>Dimensions 2.40m (L) x 1.70m (W) x 1.40m (H)</li>
              <li>Body Cube (cbm): 5.70</li>
              <li>Refrigerated transport option also available (UK only)</li>
            </ul>{ " " }
            <CallToAction to='/quote_request' text='Request Quote' />
          </div>
          <div className="img-l">
            <Img
              fluid={ data.MWB.childImageSharp.fluid }
              alt="medium wheelbase van"
            />
          </div>
        </div>
        <div className="block">
          <div className="text-l">
            <h4>Long Wheelbase Van</h4>
            <ul>
              <li>Payload (Kg): 1000 - 1300kg</li>
              <li>3 Standard UK/Euro Pallets</li>
              <li>Dimensions 3.30m (L) x 1.70m (W) x 1.50m (H)</li>
              <li>Body Cube (cbm): 11.44</li>
              <li>Refrigerated transport option also available (UK only)</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="img-r">
            <Img
              fluid={ data.LWB.childImageSharp.fluid }
              alt="long wheelbase van"
            />
          </div>

        </div>
        <div className="block">
          <div className="text-r">
            <h4>Extra Long Wheelbase van</h4>
            <ul>
              <li>Payload (Kg): 1000 - 1250kg</li>
              <li>4 standard UK pallets / 5 standard Euro Pallets</li>
              <li>Dimensions 4.00m (L) x 1.70m (W) x 1.80m (H)</li>
              <li>Body Cube (cbm): 13.79</li>
              <li>Refrigerated transport option also available (UK only)</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="spacer"></div>

          <div className="img-l">
            <Img
              fluid={ data.XLWB.childImageSharp.fluid }
              alt="extra long wheelbase van"
            />
          </div>
        </div>

        <PageHeading
          id="vehicle-size-heading"
          heading="Larger Vehicles"
        />

        <div className="block">
          <div className="text-l">
            <h4>Flat Bed Van</h4>
            <ul>
              <li>Payload (Kg): 900 - 1400kg</li>
              <li>Dimensions 5.00m (L) x 2.00m (W) x 3.00m (H)</li>
              <li>The construction industry find it to be ideal for their needs as goods can be craned or fork lifted on and off.</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="img-r">
            <Img fluid={ data.flatBed.childImageSharp.fluid } alt="flatbed van" />
          </div>
        </div>

        <div className="block">
          <div className="text-r">
            <h4>Luton Van (with / without tail lift)</h4>
            <ul>
              <li> Payload (Kg): 800 - 1000kg</li>
              <li>5 standard UK pallets / 6 Euro Pallets</li>
              <li>Dimensions 4.00m (L) x 2.00m (W) x 2.20m (H)</li>
              <li>Body Cube (cbm): 17.60</li>
              <li>Height through back door 1.9m</li>
              <li>Tail lift max weight of 500kg</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="img-l">
            <Img fluid={ data.luton.childImageSharp.fluid } alt="luton van" />
          </div>
        </div>
        <div className="block">

          <div className="text-l">
            <h4>Luton Van + Curtain (with / without tail lift)</h4>
            <ul>
              <li> Payload (Kg): 800 - 1000kg</li>
              <li>5 standard UK pallets / 6 Euro Pallets</li>
              <li>Dimensions 4.00m (L) x 2.00m (W) x 2.20m (H)</li>
              <li>Body Cube (cbm): 17.60</li>
              <li>Height through back door 1.9m</li>
              <li>Tail lift max weight of 500kg</li>
              <li>Strong side curtain with straps</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="spacer"></div>

          <div className="img-r">
            <Img
              fluid={ data.lutonCurtain.childImageSharp.fluid }
              alt="luton van with curtain side"
            />
          </div>
        </div>
        <div className="block">
          <div className="text-r">
            <h4>7.5 tonne Lorry / Curtain Side</h4>
            <ul>
              <li>Payload (Kg): 1700 – 2500kg</li>
              <li>10 standard UK pallets / 14 Euro pallets</li>
              <li>Dimensions 5.50m (L) x 2.40m (W) x 2.40m (H)</li>
              <li>Body Cube (cbm): 31.68</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="spacer"></div>

          <div className="img-l">
            <Img
              fluid={ data.sevenT.childImageSharp.fluid }
              alt="seven tonne lorry"
            />
          </div>
        </div>
        <div className="block">
          <div className="text-l">
            <h4>12 tonne Lorry</h4>
            <ul>
              <li>Payload (Kg): 5500 - 6500kg</li>
              <li>14 Standard UK Pallets 14 / 16 Euro Pallets</li>
              <li>Dimensions 6.70m (L) x 2.40m (W) x 2.40m (H)</li>
              <li>Body Cube (cbm): 38.59</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="img-r">
            <Img
              fluid={ data.twelveT.childImageSharp.fluid }
              alt="twelve tonne lorry"
            />
          </div>
        </div>
        <div className="block">
          <div className="text-r">
            <h4>18 tonne Lorry</h4>
            <ul>
              <li>Payload (Kg): 8000 - 9000kg</li>
              <li>4 Standard UK Pallets 14 / 18 Euro Pallets</li>
              <li>Dimensions 8.00m (L) x 2.30m (W) x 2.00m (H)</li>
              <li>Body Cube (cbm): 44.16</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="spacer"></div>

          <div className="img-l">
            <Img
              fluid={ data.eighteenT.childImageSharp.fluid }
              alt="eighteen tonne lorry"
            />
          </div>
        </div>
        <div className="block">
          <div className="text-l">
            <h4>26 tonne Lorry</h4>
            <ul>
              <li>Payload (Kg): 25000 - 27000kg</li>
              <li>Standard Pallets 26 / Euro Pallets 32</li>
              <li>Dimensions 13.40m (L) x 2.30m (W) x 2.00m (H)</li>
              <li>Body Cube (cbm): 77.00</li>
            </ul>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="img-r">
            <Img
              fluid={ data.twentySixT.childImageSharp.fluid }
              alt="twenty six tonne lorry"
            />
          </div>
        </div>
        <PageHeading
          className="vehicle-size-heading"
          heading="Other / Specialist Vehicles"
        />
        <div className="block">
          <div className="text-r">
            <h4>Caravan / Trailer towing</h4>
            <p>
              Local and long distance towing service throughout the UK.
              Professional towing service for touring caravans and all types of
              trailers up to 3.5ton (3500kg) individually tailored to meet your
              personal requirements.
            </p>
            <CallToAction to='/quote_request' text='Request Quote' />

          </div>
          <div className="spacer"></div>
          <div className="img-l">
            <Img fluid={ data.caravan.childImageSharp.fluid } alt="caravan" />
          </div>
        </div>

        <div className="block">
          <div className="text-l">
            <h4>Animal Transport</h4>
            <p>
              Transporting cattle or horses? Check with our friendly team to see
              what we can do to help.
            </p>
            <CallToAction to='/quote_request' text='Request Quote' />
          </div>
          {/* <div className="img-r msv">
            <Img fluid={data.horse.childImageSharp.fluid} alt="horse vehicle" />
          </div> */}

        </div>
      </div>

    </Layout>
  );
}

export const query = graphql`
  query {
    mountain: file(relativePath: { eq: "Fast van on mountain.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    motorbike: file(relativePath: { eq: "vehicle images/motorbike HL.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    car: file(relativePath: { eq: "vehicle images/a class.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    smallVan: file(
      relativePath: { eq: "vehicle images/small courier van.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    MWB: file(relativePath: { eq: "vehicle images/MWB.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    LWB: file(relativePath: { eq: "vehicle images/LWB.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    XLWB: file(relativePath: { eq: "vehicle images/XLWB.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    luton: file(relativePath: { eq: "vehicle images/luton box.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    lutonCurtain: file(
      relativePath: { eq: "vehicle images/luton curtain.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    sevenT: file(relativePath: { eq: "vehicle images/7.5t.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    twelveT: file(relativePath: { eq: "vehicle images/12t.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    eighteenT: file(relativePath: { eq: "vehicle images/18t.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    twentySixT: file(relativePath: { eq: "vehicle images/26t.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    caravan: file(relativePath: { eq: "vehicle images/caravan.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    horse: file(relativePath: { eq: "vehicle images/HORSE.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    flatBed: file(relativePath: { eq: "vehicle images/flatBed.png" }) {
      childImageSharp {
        fluid(maxWidth: 750) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;

